import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import CustomerSiteService from "../../Controller/CustomerSiteController";
import CustomerContactService from "../../Controller/CustomerContactController";
import CreateCustomerContact from "./CreateContact";
import ContactDetail from "./ContactDetail";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import useFormSubmission from '../../../Auth/Controller/AuthController';
import ModuleService from '../../../Setup/controller/ModuleController/ModuleController';
import { SidebarContext } from '../../../Layout/SidebarContext';
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import Common from '../../../Common/Common';
import HelpSite from "../../../Common/HelpLink";
import { useTranslation } from 'react-i18next';
import SendEmail from "../../../Common/SendEmail";
import MultipleEmail from "../../../Common/MultipleEmail";
import ColumnOptionDropDown from "../../../Lead/Views/LeadForms/ColumnOptionDropDown";
import Cookies from "js-cookie";
import { formatDateWithFns } from '../../../Common/DateInputFormat';
import useDateFormat from '../../../Common/fetchDateFormat';
import LockReleaseService from "../../../Setup/controller/LockReleaseController/LockModuleController";
import CustomerService from "../../Controller/CustomerController";
import ContactEmailingList from "../../../Common/EmailingName";
import MultiSearchDropDown from "../../../Common/MultiSearchDropDown";
import LeadService from "../../../Lead/Controller/LeadController";
import InboxModal from "../../../Common/InboxModal";
import JasperReportService from '../../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../../config/axiosInstance';
import Draggable from 'react-draggable';

import ReportService from "../../../Setup/controller/ReportController/ReportController";
import TermsConditionService from "../../../Setup/controller/TermsConditionController/TermsConditionController";
import BASE_URL from "../../../../config/config";
import { PDFDocument } from "pdf-lib";
import CompanySetupController from "../../../SuperAdmin/Controller/Client/SACompanyListController";
function CustomerContactPage({ ClientCompanyID, JobTab }) {
    debugger;
    const { t } = useTranslation();
    const CustomerSiteContacts = localStorage.getItem('CustomerSiteContact');
    const tableRef = useRef();
    const navigate = useNavigate();
    const CompanyID = localStorage.getItem("CompanyID");
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const { theme, toggleTheme } = useContext(ThemeContext);
    if (ClientCompanyID > 0) {
        ClientCompanyID = localStorage.getItem('ClientCompanyID');
    }
    const [CustomerSiteList, setCustomerSites] = useState([]);
    const [CustomerContactList, setCustomerContacts] = useState([]);
    const [modalInstance, setModalInstance] = useState(null);
    const [currentCustomerContact, setCurrentCustomerContact] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [selectedId, setSelectedId] = useState("0");
    const [multipleIds, setMultipleIds] = useState([]);
    const [currentPage, setCurrentPage] = useState(1); // Current page
    const [totalPages, setTotalPages] = useState(1); // Total number of pages
    const [searchQuery, setSearchQuery] = useState('');
    const [poCount, setPOCount] = useState(0);
    const activeDateFormat = useDateFormat();
    const UserID = localStorage.getItem("UserID");
    const [isMultipleEmailModalOpen, setIsMultipleEmailModalOpen] = useState(false);
    const [multipleEmails, setMultipleEmails] = useState([]);
    const [isCustomerEmailing, setIsCustomerEmailing] = useState(false);
    const [emailName, setEmailName] = useState("");
    const setSortConfigInCookie = (config) => {
        Cookies.set(`ContactSort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
    };
    const getSortConfigFromCookie = () => {
        const sortCookie = Cookies.get(`ContactSort_${CompanyID}_${UserID}`);
        return sortCookie ? JSON.parse(sortCookie) : { key: 'ClientContactID', direction: 'desc' };
    };
    const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());


    const setPageSizeInCookie = (pageSize) => {
        document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
    };
    const getPageSizeFromCookie = () => {
        const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
        return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
    };
    const [pageSize, setPageSize] = useState(getPageSizeFromCookie());
    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const [Email, setEmail] = useState();
    const [ContactIDForEmail, setContactIDForEmail] = useState();
    useEffect(() => {
        UserLockRelease();
        fetchCustomerContact(currentPage, pageSize);
    }, [currentPage, pageSize]);

    useEffect(() => {
        fetchCustomerContact(currentPage, pageSize);
    }, [sortConfig]);
    const UserLockRelease = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const CompanyID = localStorage.getItem("CompanyID");
            if (CompanyID === null || CompanyID === "null") {
                redirectCallback();
            }
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "2");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "3");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "4");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "5");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "6");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "7");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "8");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "9");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "10");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "15");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "17");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "18");

        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const fetchCustomerSites = async () => {
        try {

            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const data = await CustomerSiteService.GetAllCustomersSites(redirectCallback, ClientCompanyID);
            setCustomerSites(data);
        } catch (error) {
            console.error('Error fetching Sites:', error);
        }
    };

    const fetchCustomerContact = async (page, size) => {
        try {

            setLoading(true);
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
            const PageSize = size.toString();

            const data = await CustomerContactService.GetAllNewCustomerContacts(redirectCallback, ClientCompanyID, Start.toString(), PageSize.toString(),
                searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), emailName.toString(), searchColumns.toString());
            setCustomerContacts(data);

            const leadCount = await CustomerContactService.GetCustomerContactCount(redirectCallback, ClientCompanyID, searchQuery, emailName.toString(), searchColumns.toString());
            setPOCount(leadCount[0].TotalRecords);
            setTotalPages(Math.ceil(leadCount[0].TotalRecords / size));
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
        finally {
            setLoading(false); // Stop loading after fetching
        }
    };

    useEffect(() => {
        fetchCustomerSites();
        fetchCustomerContact("0", pageSize);
    }, [ClientCompanyID, CustomerSiteContacts]);

    const handleCreateCustomerContactClick = () => {
        fetchCustomerSites();
        localStorage.setItem('ClientContactID', "0");
        setCurrentCustomerContact(null);
        setIsModalOpen(true);
    };

    const handleCloseModal = async (isChanged) => {


        const closeModal = async () => {
            await CustomerContactService.UnLockContact(localStorage.getItem('ClientContactID'));
            if (localStorage.getItem('HasRecordUpdated') == "1") {

                fetchCustomerContact("0", pageSize);
            }
            setMultipleIds([]);
            setIsModalOpen(false);
        };

        if (isChanged != true) {
            closeModal();
            return;
        }

        Swal.fire({
            title: 'Are you sure?',
            text: `Are you sure you want to close this record?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, close it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                closeModal();
            }
        });
    };

    const [shouldAutoSelect, setShouldAutoSelect] = useState(null);
    useEffect(() => {
        if (shouldAutoSelect && CustomerContactList.length > 0) {
            const customerToSelect =
                shouldAutoSelect === 'next'
                    ? CustomerContactList[0] // first item of new page
                    : CustomerContactList[CustomerContactList.length - 1]; // last item of previous page

            localStorage.setItem('ClientContactID', customerToSelect.ClientContactID);
            setSelectedId(customerToSelect.ClientContactID);
            setShouldAutoSelect(null); // reset
        }
    }, [CustomerContactList]);
    const handleNext = async (isChanged) => {



        const nextModal = async () => {
            const customerID = localStorage.getItem('ClientContactID');
            const currentIndex = CustomerContactList.findIndex(item => item.ClientContactID.toString() === customerID);
            await CustomerContactService.UnLockContact(customerID);
            if (currentIndex < CustomerContactList.length - 1) {
                const nextLead = CustomerContactList[currentIndex + 1];
                localStorage.setItem('ClientContactID', nextLead.ClientContactID);
                setSelectedId(nextLead.ClientContactID);
            } else if (currentPage < totalPages) {
                setShouldAutoSelect('next'); // flag for useEffect
                setCurrentPage(prev => prev + 1);
            }
        };

        if (isChanged != true) {
            nextModal();
            return;
        }

        Swal.fire({
            title: 'Are you sure?',
            text: `Are you sure you want to go to next record?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then(async (result) => {
            if (result.isConfirmed) {
                nextModal();
            }
        });
    };

    const handlePrevious = async (isChanged) => {
        const prevModal = async () => {
            const leadID = localStorage.getItem('ClientContactID');
            const currentIndex = CustomerContactList.findIndex(item => item.ClientContactID.toString() === leadID);
            await CustomerContactService.UnLockContact(leadID);
            if (currentIndex > 0) {
                const prevLead = CustomerContactList[currentIndex - 1];
                localStorage.setItem('ClientContactID', prevLead.ClientContactID);
                setSelectedId(prevLead.ClientContactID);
            } else if (currentPage > 1) {
                setShouldAutoSelect('previous'); // flag for useEffect
                setCurrentPage(prev => prev - 1);
            }
        };

        if (isChanged != true) {
            prevModal();
            return;
        }

        Swal.fire({
            title: 'Are you sure?',
            text: `Are you sure you want to go to previous record?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then(async (result) => {
            if (result.isConfirmed) {
                prevModal();
            }
        });
    };




    const handleEditClick = async (contact) => {
        const IsAlreadyLeadID = localStorage.getItem('ClientContactID');
        if (IsAlreadyLeadID) {
            await CustomerContactService.UnLockContact(IsAlreadyLeadID);
        }
        localStorage.setItem('PrevPath', "ContactList");
        fetchCustomerSites();
        localStorage.setItem('ClientContactID', contact.ClientContactID);
        setCurrentCustomerContact(contact);
        setSelectedId(contact.ClientContactID);
        setIsModalOpen(true);

    };


    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation(); // Prevent the row click event
        const idsToDelete = ID > 0 ? [ID] : multipleIds;
        if (idsToDelete.length > 0) {
            Swal.fire({
                title: t('deleteConfirmationTitle'),
                text: t('deleteConfirmationText'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        await CustomerContactService.DeleteCustomerContact(idsToDelete);
                        setMultipleIds([]);
                        fetchCustomerContact("0", pageSize);
                        Swal.fire(
                            t('deleteSuccess'),
                            t('deleteSuccessText'),
                            'success'
                        );
                    } catch (error) {
                        console.error('Error deleting job:', error);
                        Swal.fire(
                            'Error!',
                            'There was a problem deleting the record.',
                            'error'
                        );
                    }
                }
            });
        }
        else {
            Swal.fire(
                'Error!',
                'Please check at least one record to delete contact.',
                'warning'
            );
        }
    };
    const handleSuccess = () => {
        fetchCustomerContact("0", pageSize); // Refresh the list after submission
        handleCloseModal();   // Close the modal
    };
    const [lastCheckedIndex, setLastCheckedIndex] = useState(null);

    // NEW: handle click (not change)
    const handleCheckboxClick = (event, id, index) => {
        event.stopPropagation();

        const isChecked = event.target.checked;

        if (event.shiftKey && lastCheckedIndex !== null) {
            const start = Math.min(lastCheckedIndex, index);
            const end = Math.max(lastCheckedIndex, index);
            const idsInRange = CustomerContactList.slice(start, end + 1).map(l => l.ClientContactID);

            setMultipleIds(prev => {
                const s = new Set(prev);
                if (isChecked) {
                    idsInRange.forEach(x => s.add(x));     // range select
                } else {
                    idsInRange.forEach(x => s.delete(x));  // range unselect
                }
                return Array.from(s);
            });
        } else {
            // normal single toggle
            setMultipleIds(prev => {
                const s = new Set(prev);
                if (isChecked) s.add(id); else s.delete(id);
                return Array.from(s);
            });
        }

        // Always update the anchor index
        setLastCheckedIndex(index);
    };
    const HelpLink = localStorage.getItem('HelpLink');
    const truncateText = (text, maxLength = 25) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const handlePageChange = (page) => {
        setCustomerContacts([]);
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);

        }
    };
    const handlePageSizeChange = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize);
        setPageSizeInCookie(newPageSize);
        setCurrentPage(1); // Reset to the first page
    };
    const handleSearchButtonClick = async () => {
        setCurrentPage(1); // Reset to first page
        setCustomerContacts([]); // Clear previous data
        const query = searchQuery.toLowerCase(); // Use current searchQuery state
        let columnsToSearch = searchColumns.length > 0
            ? searchColumns.join(",")
            : "ALL";
        setSearchOptions(columnsToSearch);
        const leadData = await CustomerContactService.GetAllNewCustomerContacts(redirectCallback, ClientCompanyID, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), emailName.toString(), columnsToSearch.toString());
        setCustomerContacts(leadData);

        const leadCount = await CustomerContactService.GetCustomerContactCount(redirectCallback, ClientCompanyID, searchQuery, emailName.toString(), columnsToSearch.toString());
        setPOCount(leadCount[0].TotalRecords);
        setTotalPages(Math.ceil(leadCount[0].TotalRecords / pageSize)); // Set total pages dynamically
    };
    const handleSort = async (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        const newConfig = { key, direction };
        setSortConfig(newConfig);
        setSortConfigInCookie(newConfig);
        setCurrentPage(1);

        setSortConfig({ key, direction });
        const porderData = await CustomerContactService.GetAllNewCustomerContacts(redirectCallback, ClientCompanyID, "1", pageSize.toString(),
            searchQuery.toString(), key.toString(), direction.toString(), emailName.toString(), searchColumns.toString());

        const porderCount = await CustomerContactService.GetCustomerContactCount(redirectCallback, ClientCompanyID, searchQuery, emailName.toString(), searchColumns.toString());

        setPOCount(porderCount[0].TotalRecords);
        setCustomerContacts(porderData);

        setTotalPages(Math.ceil(porderCount[0].TotalRecords / pageSize));
    };
    const handleEmailClick = async (event, contact) => {
        event.stopPropagation();
        setEmail(contact.Email);
        setContactIDForEmail(contact.ClientContactID)
        setIsEmailModalOpen(true);
    };
    const handleCloseEmailModal = async () => {

        setIsEmailModalOpen(false);
        fetchCustomerContact("0", pageSize);
    };

    const defaultColumns = [
        "contact",
        "siteName",
        "telephone",
        "email",
        "ModifiedBy",
        "AssignTo",
    ];

    const columnOptions = [
        { value: "contact", label: "Contact" },
        { value: "siteName", label: "Site Name" },
        { value: "telephone", label: "Telephone" },
        { value: "email", label: "	Email" },
        { value: "UpdatedDate", label: "Updated Date" },
        { value: "ModifiedBy", label: "ModifiedBy" },
        { value: "AssignTo", label: "AssignTo" }
    ];
    const getStoredColumns = () => {
        const storedColumns = Cookies.get(`ContactColumns_${CompanyID}`);
        return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
    };

    const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
    const handleColumnChange = (selectedOptions) => {
        setVisibleColumns(selectedOptions);

        // Save selection to cookies (valid for 1 year)
        Cookies.set(`ContactColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
    };
    const handleExportExcel = async () => {
        if (multipleIds.length === 0) {
            Swal.fire(
                'Warning!',
                'Please select at least one record to export.',
                'warning'
            );
            return;
        }
        setLoading(true);
        try {
            const selectedContacts = CustomerContactList.filter(x =>
                multipleIds.includes(x.ClientContactID)
            );
            if (!selectedContacts || selectedContacts.length === 0) {
                Swal.fire(
                    'Warning!',
                    'No data to export.',
                    'warning'
                );
                return;
            }
            const headers = visibleColumns.map(col => columnOptions.find(opt => opt.value === col)?.label || col);
            const rows = selectedContacts.map(row =>
                visibleColumns.map(col => {
                    let value = '';
                    switch (col) {
                        case 'contact':
                            value = `${row.Title ?? ''} ${row.FirstName ?? ''} ${row.SurName ?? ''}`;
                            break;
                        case 'siteName':
                            value = row.BranchName ?? '';
                            break;
                        case 'telephone':
                            value = row.Phone ?? '';
                            break;
                        case 'email':
                            value = row.Email ?? '';
                            break;
                        case 'AssignTo':
                            value = row.AssignTo ?? '';
                            break;
                        case 'UpdatedDate':
                            value = formatDateWithFns(row.UpdatedDate, activeDateFormat);
                            break;
                        default:
                            value = row[col] ?? '';
                    }
                    return `"${value.toString().replace(/"/g, '""')}"`; // Escape double quotes
                }).join(',')
            );

            const csvContent = [
                headers.join(','), // CSV Header
                ...rows            // CSV Rows
            ].join('\n');

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'ContactList.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        catch (error) {
            console.error('Error fetching Teams:', error);
        }
        finally {
            setLoading(false); // Stop loading after fetching
        }
    };
    const handleSendMultipleEmail = async () => {
        if (multipleIds.length > 0) {

            const emails = multipleIds
                .map(id => {
                    const contact = CustomerContactList.find(c => c.ClientContactID === id);
                    return contact ? contact.Email : '';
                })
                .filter(email => email);
            setMultipleEmails(emails);
            setIsMultipleEmailModalOpen(true);

        }
        else {
            Swal.fire(
                'Error!',
                'Please select at least one record to send email.',
                'error'
            );
        }
    }
    const [isEmailingModalOpen, setIsEmailingModalOpen] = useState(false);
    const [emailingName, setEmailingName] = useState("");
    const handleEmailing = async () => {
        if (multipleIds.length === 0) {
            Swal.fire('Warning!', 'Please select at least one record.', 'warning');
            return;
        }
        setIsEmailingModalOpen(true); // open the modal instead of calling the API directly
    };
    const handleConfirmEmailing = async () => {

        if (!emailingName.trim()) {
            Swal.fire('Warning!', 'Please enter a name.', 'warning');
            return;
        }
        try {
            await CustomerService.AddEmailing(multipleIds, "15", emailingName);
            setMultipleIds([]);
            setSelectedId("0");
            Swal.fire('Success!', `${multipleIds.length} record(s) have been saved successfully.`, 'success');
        }
        catch (error) {
            Swal.fire('Error!', 'Failed to save record.', 'error');
        } finally {
            setIsEmailingModalOpen(false);
            setEmailingName("");
        }
    }
    const handleEmailingList = async () => {
        setIsCustomerEmailing(true);
    }
    const handleCloseEmailListModal = async () => {
        setIsCustomerEmailing(false);
    };
    const handleSelect = async (EmailingName) => {
        setEmailName(EmailingName);
        setCurrentPage(1);
        setCustomerContacts([]);
        const query = searchQuery.toLowerCase();
        setIsCustomerEmailing(false);

        const leadData = await CustomerContactService.GetAllNewCustomerContacts(redirectCallback, ClientCompanyID, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), EmailingName.toString(), searchColumns.toString());
        setCustomerContacts(leadData);

        const leadCount = await CustomerContactService.GetCustomerContactCount(redirectCallback, ClientCompanyID, searchQuery, EmailingName.toString(), searchColumns.toString());
        setPOCount(leadCount[0].TotalRecords);
        setTotalPages(Math.ceil(leadCount[0].TotalRecords / pageSize));
    };
    const handleReset = async () => {
        debugger;
        setEmailName("");
        setCurrentPage(1);
        setCustomerContacts([]);
        const query = searchQuery.toLowerCase();
        setIsCustomerEmailing(false);

        const leadData = await CustomerContactService.GetAllNewCustomerContacts(redirectCallback, ClientCompanyID, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), "", searchColumns.toString());
        setCustomerContacts(leadData);

        const leadCount = await CustomerContactService.GetCustomerContactCount(redirectCallback, ClientCompanyID, searchQuery, "", searchColumns.toString());
        setPOCount(leadCount[0].TotalRecords);
        setTotalPages(Math.ceil(leadCount[0].TotalRecords / pageSize));
    };
    const defaultColumnsForSearch = [
        "contact",
        "siteName",
        "telephone",
        "email",
        "AssignTo",
        "ModifiedBy"
    ];
    const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
    const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
    const columnSearchOptions = [
        { value: "contact", label: "Contact" },
        { value: "siteName", label: "Site Name" },
        { value: "telephone", label: "Telephone" },
        { value: "email", label: "	Email" },
        { value: "ModifiedBy", label: "ModifiedBy" },
        { value: "AssignTo", label: "AssignTo" }


    ];
    const handleSearchColumnChange = (selectedOptions) => {
        setSearchColumns(selectedOptions);

    };
    const [inboxModalOpen, setInboxModalOpen] = useState(false);
    const handleInboxEmail = async (event) => {
        if (multipleIds.length > 0) {
            event.preventDefault();
            setInboxModalOpen(true);
        }
        else {
            Swal.fire(
                'Error!',
                'Please check at least one record to process.',
                'warning'
            );
        }
    }
    const handleCloseInbox = () => {
        setInboxModalOpen(false);
    };
    const handleInboxSave = async (selectedEmails) => {
        const LeadID = multipleIds[0];
        const reponse = await LeadService.CreateCommuncationInbox(selectedEmails, LeadID, "Contact");
        if (reponse.message == "Record saved successfully") {
            Swal.fire(
                'Success!',
                'Your record has been saved.',
                'success'
            );
        }
    };
    const getInitialWidths = () => {
        const saved = Cookies.get(`ContactColumnWidths_${CompanyID}_${UserID}`);
        const defaults = {};

        visibleColumns.forEach(col => {
            defaults[col] = 110;
        });

        if (!saved) return defaults;

        const parsed = JSON.parse(saved);
        const applied = {};

        visibleColumns.forEach(col => {
            applied[col] = parsed[col] || 110;
        });

        return applied;
    };

    const [columnWidths, setColumnWidths] = useState(getInitialWidths);
    const startX = useRef(0);
    const startWidth = useRef(0);
    const resizingColumn = useRef(null);
    const MIN_COL_WIDTH = 60;

    /**
     * Load widths from cookie when visibleColumns changes
     */
    useEffect(() => {
        const savedWidths = Cookies.get(`ContactColumnWidths_${CompanyID}_${UserID}`);
        if (savedWidths) {
            const parsed = JSON.parse(savedWidths);
            setColumnWidths((prev) => ({
                ...prev,
                ...parsed
            }));
        }
    }, [CustomerContactList]);


    /**
     * Start Column Resize
     */
    const startResize = (e, key) => {
        e.stopPropagation();
        startX.current = e.clientX;
        resizingColumn.current = key;

        const th = e.target.closest("th");   // FIXED HERE
        startWidth.current = th.offsetWidth;

        document.addEventListener("mousemove", resizeColumn);
        document.addEventListener("mouseup", stopResize);
    };

    /**
     * Resize Column dynamically
     */
    const resizeColumn = (e) => {
        if (!resizingColumn.current) return;

        const delta = e.clientX - startX.current;
        const newWidth = Math.max(startWidth.current + delta, MIN_COL_WIDTH);

        setColumnWidths(prev => ({
            ...prev,
            [resizingColumn.current]: newWidth
        }));
    };
    useEffect(() => {
        setColumnWidths(getInitialWidths());
    }, [visibleColumns]);

    /**
     * Stop resizing and save to cookie
     */
    const stopResize = () => {
        document.removeEventListener("mousemove", resizeColumn);
        document.removeEventListener("mouseup", stopResize);

        const key = resizingColumn.current;
        if (key) {
            setColumnWidths(prev => {
                // Save using the most recent updated state
                Cookies.set(
                    `ContactColumnWidths_${CompanyID}_${UserID}`,
                    JSON.stringify(prev),
                    { expires: 365 }
                );
                return prev;
            });
        }

        resizingColumn.current = null;
    };


    /**
     * Auto-fit column width
     */
    const autoFitColumn = (key) => {
        const cells = document.querySelectorAll(`[data-col='${key}']`);
        let maxWidth = 0;

        cells.forEach(cell => {
            maxWidth = Math.max(maxWidth, cell.scrollWidth);
        });

        const newWidth = maxWidth + 20;

        const updated = { ...columnWidths, [key]: newWidth };

        setColumnWidths(updated);

        Cookies.set(
            `ContactColumnWidths_${CompanyID}_${UserID}`,
            JSON.stringify(updated),
            { expires: 365 }
        );
    };
    const handleSyncInboxEmail = async (event) => {
        Swal.fire({
            title: 'Are you sure?',
            text: `You are about to sync inbox emails`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await LeadService.SyncInboxEmail();
                    if (response.message === "Record saved successfully") {
                        Swal.fire(
                            'Success!',
                            'Your request for syning the inbox email is process successfully.',
                            'success'
                        );
                    }
                } catch (error) {

                    Swal.fire(
                        'Error!',
                        'There was a problem syncing the record.',
                        'error'
                    );
                }
            }
        });
    }

    const [showPdfModal, setShowPdfModal] = useState(false);
    const [imageData, setImageData] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [reportTitle, setReportTitle] = useState('');
    const [reportLink, setReportLink] = useState('');
    const [inputValues, setInputValues] = useState({});
    const [outputData, setOutputData] = useState([]);
    const [error, setError] = useState(null);
    const getMergedPDFBytes = async (id) => {
        try {
            const currentInputValues = {
                ClientID: localStorage.getItem("CompanyID"),
                ID: id
            };

            const redirectCallback = () => navigate('/');

            let reportData = await ReportService.GetCompanyReports(redirectCallback, "15");
            reportData = reportData.filter(x => x.IsDefault.toString() === "1");

            const reportID = reportData.length > 0 ? reportData[0].ID : 120;
            const JasperReport = await JasperReportService.GetJasperReportByID(reportID);

            const queryObjMain = {
                ...currentInputValues,
                format: 'pdf',
                ReportName: JasperReport[0].ReportName,
                ReportType: JasperReport[0].ReportType,
                name: JasperReport[0].ReportName
            };

            const responseMain = await axiosInstance.get(
                `/Dashboard/ProxyReport?${new URLSearchParams(queryObjMain)}`,
                { responseType: 'blob' }
            );

            const mainPdfBytes = await responseMain.data.arrayBuffer();

            const pdfDoc = await PDFDocument.load(mainPdfBytes);

            return pdfDoc;

        } catch (err) {
            console.error(err);
            return null;
        }
    };
    const handlePrintUser = async (event) => {
        event.stopPropagation();


        setLoading(true);
        const includeTerms = false;

        if (multipleIds.length > 0) {
            try {
                const finalMergedPdf = await PDFDocument.create();

                // ================= MERGE INVOICES =================
                for (const id of multipleIds) {

                    const pdfDoc = await getMergedPDFBytes(id);

                    if (!pdfDoc) continue;

                    const pages = await finalMergedPdf.copyPages(
                        pdfDoc,
                        pdfDoc.getPageIndices()
                    );

                    pages.forEach(page => finalMergedPdf.addPage(page));
                }


                const finalBytes = await finalMergedPdf.save();
                const finalBlob = new Blob([finalBytes], { type: "application/pdf" });

                const finalUrl = URL.createObjectURL(finalBlob);
                setLoading(false);
                setPdfUrl(finalUrl);
                setShowPdfModal(true);

            } catch (err) {
                console.error('Error executing report:', err);
                setError('Failed to execute the report.');
            }
        } else {
            Swal.fire(
                'Error!',
                'Please check at least one record to print job.',
                'warning'
            );
        }
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    return (
        <div>
            {(ClientCompanyID === 0 || ClientCompanyID === "") && (

                <Common showAddButton={'yes'} handleAddTask={handleCreateCustomerContactClick}
                    showDeleteButton={'yes'} handleDeleteItem={handleDeleteClick}
                    ModuleID={"15"}
                    showExportButton={'yes'} handleExportExcel={handleExportExcel}
                    showEmailButton={'yes'} handleSendEmail={handleSendMultipleEmail}
                    showSendEmailing={'yes'} handleEmailing={handleEmailing}
                    showEmailingList={'yes'} handleEmailingList={handleEmailingList}
                    showResetEmailingList={'yes'} handleReset={handleReset}
                    showInboxEmail={'yes'} handleInboxEmail={handleInboxEmail}
                    showSyncInboxEmail={'yes'} handleSyncInboxEmail={handleSyncInboxEmail}
                    assignmentTitle="Manage Contacts"
                    showPrintUser={'yes'} handlePrintUser={handlePrintUser}
                    HelpFormName="Contact List" HelpModule="31"
                    RecordID={multipleIds}
                />
            )}
            {loading && (
                <div class="loading">
                    <div class="d-table">
                        <div class="d-tablecell">
                            <span class="loader">
                                <span class="loader-inner"></span>
                            </span>
                        </div>
                    </div>
                </div>
            )}
            {(ClientCompanyID === 0 || ClientCompanyID === "") && (
                <div className="main-content-header">
                    <div className="row">
                        <div className="col-xl-2">
                            <h1>{t('Cotitle')}</h1>
                        </div>

                        <div className="col-xl-10 d-flex justify-content-end">
                            <div className="col-sm-2">

                            </div>
                            <ColumnOptionDropDown
                                options={columnOptions}
                                selectedOptions={visibleColumns}
                                onChange={handleColumnChange}
                            />


                        </div>
                    </div>
                </div>
            )}
            {(ClientCompanyID > 0) && (
                <div>

                    <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                        <div className="col-sm-3">
                            <button className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleCreateCustomerContactClick}>
                                <i className="icofont-plus" aria-hidden="true"> {t('addNew')}</i>
                            </button>
                        </div>

                        <div className="col-xl-9 d-flex justify-content-end">

                            <ColumnOptionDropDown
                                options={columnOptions}
                                selectedOptions={visibleColumns}
                                onChange={handleColumnChange}
                            />

                        </div>
                    </div>
                </div>
            )}
            <div className="row">
                <div className="col-xl-12">
                    <div className="card mb-30">
                        <div className="card-body">
                            <div className="table-responsive" style={{ overflow: "visible" }}>
                                <div className="row mb-3">
                                    <div className="col-sm-1">
                                        <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                                            <option value={10}>10</option>
                                            <option value={25}>25</option>
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                            <option value={500}>500</option>
                                            <option value={1000}>1000</option>
                                        </select>
                                    </div>
                                    <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                                    <div className="col-sm-6"></div>
                                    <div className="col-sm-1 d-flex align-items-center justify-content-end">
                                        <span className="me-2">Search</span>

                                        <MultiSearchDropDown
                                            options={columnSearchOptions}
                                            selectedOptions={searchColumns}
                                            onChange={handleSearchColumnChange}
                                        />
                                    </div>
                                    <div className="col-sm-2 d-flex justify-content-end">

                                        <input
                                            type="text"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)} // Update searchQuery state
                                            className="form-control me-2" // Add margin to separate input and button
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    handleSearchButtonClick();
                                                }
                                            }}
                                        />
                                        <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                                            <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                                        </button>
                                    </div>



                                </div>
                                <div style={{ maxHeight: "80vh", overflow: "auto" }}>
                                    <table
                                        style={{
                                            tableLayout: "fixed",
                                            width: "max-content",
                                            minWidth: "100%"
                                        }}
                                        className="table m-0 table-hover"
                                        ref={tableRef}
                                    >
                                        <thead classname="table-light" style={{ position: "sticky", top: 0, zindex: 2 }}>
                                            <tr>
                                                {(ClientCompanyID === 0 || ClientCompanyID === "") && (
                                                    <th
                                                        className="checkbox-header"
                                                        style={{
                                                            width: "40px",
                                                            minWidth: "40px",
                                                            maxWidth: "40px",
                                                            position: "sticky",
                                                            left: 0,
                                                            zIndex: 5,

                                                        }}
                                                    ></th>
                                                )}
                                                {visibleColumns.includes("contact") &&
                                                    <th onClick={() => handleSort('Title')}
                                                        style={{
                                                            width: `${columnWidths?.Title}px`,
                                                            minWidth: `${MIN_COL_WIDTH}px`
                                                        }}

                                                        className="resizable ellipsis">{t('contact')}
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'Title'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i><div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "Title");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("Title")}
                                                        />
                                                    </th>
                                                }
                                                {visibleColumns.includes("siteName") &&
                                                    <th onClick={() => handleSort('BranchName')}
                                                        style={{
                                                            width: `${columnWidths?.BranchName}px`,
                                                            minWidth: `${MIN_COL_WIDTH}px`
                                                        }}
                                                        className="resizable ellipsis">{t('siteName')}
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'BranchName'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i><div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "BranchName");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("BranchName")}
                                                        />
                                                    </th>
                                                }
                                                {visibleColumns.includes("telephone") &&
                                                    <th onClick={() => handleSort('Phone')}

                                                        style={{
                                                            width: `${columnWidths?.Phone}px`,
                                                            minWidth: `${MIN_COL_WIDTH}px`
                                                        }}
                                                        className="resizable ellipsis">{t('telephone')}
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'Phone'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i><div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "Phone");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("Phone")}
                                                        />
                                                    </th>
                                                }
                                                {visibleColumns.includes("email") &&
                                                    <th onClick={() => handleSort('Email')}

                                                        style={{
                                                            width: `${columnWidths?.Email}px`,
                                                            minWidth: `${MIN_COL_WIDTH}px`
                                                        }}
                                                        className="resizable ellipsis">{t('email')}
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'Email'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i><div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "Email");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("Email")}
                                                        />
                                                    </th>
                                                }
                                                {visibleColumns.includes("AssignTo") &&
                                                    <th onClick={() => handleSort('AssignTo')}

                                                        style={{
                                                            width: `${columnWidths?.AssignTo}px`,
                                                            minWidth: `${MIN_COL_WIDTH}px`
                                                        }}
                                                        className="resizable ellipsis">Assign To
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'AssignTo'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i><div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "AssignTo");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("AssignTo")}
                                                        />
                                                    </th>
                                                }
                                                {visibleColumns.includes("UpdatedDate") &&
                                                    <th onClick={() => handleSort('UpdatedDate')} style={{ width: columnWidths.UpdatedDate, minWidth: MIN_COL_WIDTH }}
                                                        className="resizable ellipsis">Last Action
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'UpdatedDate'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i><div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "UpdatedDate");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("UpdatedDate")}
                                                        />
                                                    </th>
                                                }
                                                {visibleColumns.includes("ModifiedBy") &&
                                                    <th onClick={() => handleSort('ModifiedBy')}
                                                        style={{
                                                            width: `${columnWidths?.ModifiedBy}px`,
                                                            minWidth: `${MIN_COL_WIDTH}px`
                                                        }}
                                                        className="resizable ellipsis">Modified By
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'ModifiedBy'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i>
                                                        <div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "ModifiedBy");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("ModifiedBy")}
                                                        />
                                                    </th>
                                                }
                                                {(ClientCompanyID > 0) && (
                                                    <th style={{ width: `${100 / visibleColumns.length}%`, "textAlign": "right" }}>{t('actions')}</th>
                                                )}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {CustomerContactList.map((contact, index) => (
                                                <tr key={contact.ClientContactID}
                                                    onClick={() => handleEditClick(contact)}
                                                    style={{
                                                        backgroundColor: selectedId.toString() === contact.ClientContactID.toString() ? 'rgb(197, 218, 237)' : '', // Highlight background
                                                        cursor: 'pointer',
                                                    }}
                                                    className={contact.HeadOffice === 1 ? 'boldRow' : ''}>
                                                    {(ClientCompanyID === 0 || ClientCompanyID === "") && (
                                                        <td
                                                            className="checkbox-cell"
                                                            onClick={(e) => e.stopPropagation()}
                                                            style={{
                                                                width: "40px",
                                                                minWidth: "40px",
                                                                maxWidth: "40px",
                                                                position: "sticky",
                                                                left: 0,
                                                                zIndex: 3,
                                                                backgroundColor:
                                                                    selectedId.toString() === contact.ClientContactID.toString()
                                                                        ? 'rgb(197, 218, 237)'
                                                                        : '#fff'
                                                            }}
                                                        >
                                                            <div
                                                                className="checkbox-hover-area"
                                                                onClick={(event) => handleCheckboxClick(event, contact.ClientContactID, index)}
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    checked={multipleIds.includes(contact.ClientContactID)}
                                                                    readOnly
                                                                />
                                                            </div>
                                                        </td>
                                                    )}
                                                    {visibleColumns.includes("contact") && <td style={{
                                                        width: columnWidths.contact,
                                                        minWidth: MIN_COL_WIDTH,
                                                    }} className="no-wrap ellipsis">{contact.Title} {contact.FirstName} {contact.SurName}</td>}
                                                    {visibleColumns.includes("siteName") && <td style={{
                                                        width: columnWidths.BranchName,
                                                        minWidth: MIN_COL_WIDTH,
                                                    }} className="no-wrap ellipsis">{contact.BranchName}</td>}
                                                    {visibleColumns.includes("telephone") && <td style={{
                                                        width: columnWidths.Phone,
                                                        minWidth: MIN_COL_WIDTH,
                                                    }} className="no-wrap ellipsis">
                                                        <a href={`tel:${contact.Phone}`} onClick={(e) => e.stopPropagation()}>
                                                            {contact.Phone}
                                                        </a>
                                                    </td>}
                                                    {visibleColumns.includes("email") &&
                                                        <td style={{
                                                            width: columnWidths.Email,
                                                            minWidth: MIN_COL_WIDTH,
                                                        }} className="no-wrap ellipsis">
                                                            <a href='#' onClick={(event) => handleEmailClick(event, contact)}>
                                                                {contact.Email}
                                                            </a>
                                                        </td>
                                                    }
                                                    {visibleColumns.includes("AssignTo") && <td style={{
                                                        width: columnWidths.AssignTo,
                                                        minWidth: MIN_COL_WIDTH,
                                                    }} className="no-wrap ellipsis">
                                                        {contact.AssignTo ? (
                                                            <div
                                                                title={contact.AssignTo}
                                                                style={{
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    width: "25px",
                                                                    height: "25px",
                                                                    borderRadius: "50%",
                                                                    backgroundColor: "#007bff",
                                                                    color: "white",
                                                                    fontWeight: "bold",
                                                                    fontSize: "14px",
                                                                }}
                                                            >
                                                                {contact.AssignTo.split(" ")
                                                                    .map(word => word.charAt(0).toUpperCase())
                                                                    .join("")}
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </td>}
                                                    {visibleColumns.includes("UpdatedDate") && <td style={{
                                                        width: columnWidths.UpdatedDate,
                                                        minWidth: MIN_COL_WIDTH,
                                                    }} className="no-wrap ellipsis">{formatDateWithFns(contact.UpdatedDate, activeDateFormat)}  </td>}
                                                    {visibleColumns.includes("ModifiedBy") && <td style={{
                                                        width: columnWidths.ModifiedBy,
                                                        minWidth: MIN_COL_WIDTH,
                                                    }} className="no-wrap ellipsis">
                                                        {contact.ModifiedBy ? (
                                                            <div
                                                                title={contact.ModifiedBy}
                                                                style={{
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    width: "25px",
                                                                    height: "25px",
                                                                    borderRadius: "50%",
                                                                    backgroundColor: "#368938",
                                                                    color: "white",
                                                                    fontWeight: "bold",
                                                                    fontSize: "14px",
                                                                }}
                                                            >
                                                                {contact.ModifiedBy.split(" ")
                                                                    .map(word => word.charAt(0).toUpperCase())
                                                                    .join("")}
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </td>}
                                                    {(ClientCompanyID > 0) && (
                                                        <td className={`rightColumn ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} style={{ "textAlign": "right" }}>

                                                            <button style={{ "background": "none", "border": "none" }} className="text-danger" onClick={(event) => handleDeleteClick(event, contact.ClientContactID)}>
                                                                <i className="icofont-ui-delete" aria-hidden="true"></i>
                                                            </button>
                                                        </td>
                                                    )}
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot style={{ position: "sticky", bottom: 0, zIndex: 2, backgroundColor: "white" }}>
                                            <tr>
                                                <td colSpan={visibleColumns.length + 1}>
                                                    <div className="pagination-controls" style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                        Showing {1 + (currentPage * pageSize) - pageSize} to {currentPage * (Math.min(poCount, pageSize))} of {poCount} entries

                                                        {/* Last Page Button */}
                                                        <button
                                                            style={{ float: "right", marginLeft: "5px" }}
                                                            className='btn btn-info'
                                                            onClick={() => handlePageChange(totalPages)} // Navigate to last page
                                                            disabled={currentPage === totalPages}
                                                        >
                                                            <img src="assets/img/resources/last.png" alt="Add icon" style={{ height: "10px" }} />   Last
                                                        </button>

                                                        {/* Next Page Button */}
                                                        <button
                                                            style={{ float: "right", marginLeft: "5px" }}
                                                            className='btn btn-info'
                                                            onClick={() => handlePageChange(currentPage + 1)}
                                                            disabled={currentPage === totalPages}
                                                        >
                                                            <img src="assets/img/resources/next-icon.png" alt="Add icon" style={{ height: "10px" }} />  Next
                                                        </button>

                                                        <span style={{ marginLeft: "10px", marginRight: "10px", float: "right" }}>
                                                            Page {currentPage} of {totalPages}
                                                        </span>

                                                        {/* Previous Page Button */}
                                                        <button
                                                            style={{ float: "right", marginRight: "5px", marginLeft: "5px" }}
                                                            className='btn btn-info'
                                                            onClick={() => handlePageChange(currentPage - 1)}
                                                            disabled={currentPage === 1}
                                                        >
                                                            <img src="assets/img/resources/pevious-icon.png" alt="Add icon" style={{ height: "10px" }} />  Prev
                                                        </button>

                                                        {/* First Page Button */}
                                                        <button
                                                            style={{ float: "right" }}
                                                            className='btn btn-info'
                                                            onClick={() => handlePageChange(1)} // Navigate to first page
                                                            disabled={currentPage === 1}
                                                        >
                                                            <img src="assets/img/resources/first.png" alt="Add icon" style={{ height: "10px" }} />  First
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                isModalOpen && (
                    <ContactDetail
                        onClose={handleCloseModal}
                        CustomerSites={CustomerSiteList}
                        ClientCompanyID={ClientCompanyID}
                        ClientContactID={localStorage.getItem('ClientContactID')}
                        onNext={handleNext} onPrevious={handlePrevious}
                    />
                )
            }
            {isEmailingModalOpen && (
                <div className="modal show fade" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Add Emailing Name</h5>
                                <button type="button" className="btn-close" onClick={() => setIsEmailingModalOpen(false)}></button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3" style={{ "marginLeft": "0px", "marginRight": "0px", "marginTop": "10px" }}>

                                    <div className="col-sm-12">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Name"
                                            value={emailingName}
                                            onChange={(e) => setEmailingName(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setIsEmailingModalOpen(false)}>Cancel</button>
                                <button className="btn btn-primary" onClick={handleConfirmEmailing}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {isEmailModalOpen && (
                <SendEmail onClose={handleCloseEmailModal} ToEmail={Email} Module="Customer" ModuleID={ContactIDForEmail} />
            )}
            {isMultipleEmailModalOpen && (
                <MultipleEmail
                    onClose={() => setIsMultipleEmailModalOpen(false)}
                    ToEmail={multipleEmails} // remove empty strings
                    Module="Contact"
                    ModuleID={ClientCompanyID}
                    MultipleIDs={multipleIds}
                />
            )}
            {isCustomerEmailing && (
                <ContactEmailingList
                    show={isCustomerEmailing}
                    onClose={handleCloseEmailListModal}
                    ModuleID={"15"}
                    handleSelect={handleSelect}
                    OnReset={handleReset}
                />
            )}
            {inboxModalOpen && (
                <InboxModal onSave={handleInboxSave} onClose={handleCloseInbox} />
            )}
            {showPdfModal && pdfUrl && (
                <div className="modal fade show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">PDF Report</h5>
                                    <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            )}
        </div >
    );
}

export default CustomerContactPage;
